import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,{attrs:{"src":_vm.imgComputed,"height":"100vh"}},[_c(VBtn,{staticStyle:{"position":"absolute","bottom":"5rem","left":"5rem"},attrs:{"large":"","rounded":"","depressed":"","to":"/inicio"}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-chevron-left")]),_vm._v("\n    Regresar a inicio\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }